/**
 * Normalized goals CSV import template — shared by the single-client
 * (GoalImportModal) and multi-client onboarding (GoalsOnboardingImport) flows
 * so the column contract and sample row stay in sync.
 *
 * Single-client mode attaches every row to the client selected in the UI, so the
 * `client_external_id` column is neither needed nor read — its template omits it.
 * Multi-client onboarding keeps it to fan rows out to the right client.
 */

import { downloadTemplateCsv } from '../shared/bulkUploadUtils';

const GOAL_COLUMNS = [
  'goal_key',
  'parent_goal_key',
  'domain',
  'program',
  'goal',
  'target',
  'status',
  'date_initiated',
  'date_met',
];

/** Multi-client onboarding template: includes client_external_id (fan-out key). */
export const GOAL_IMPORT_TEMPLATE_HEADERS = ['client_external_id', ...GOAL_COLUMNS];

/** Single-client template: no client_external_id (the client is chosen in the UI). */
export const GOAL_IMPORT_TEMPLATE_HEADERS_SINGLE = GOAL_COLUMNS;

export const goalTemplateHeaders = (mode: 'single' | 'multi'): string[] =>
  mode === 'single' ? GOAL_IMPORT_TEMPLATE_HEADERS_SINGLE : GOAL_IMPORT_TEMPLATE_HEADERS;

const SAMPLE_ROW: Record<string, string> = {
  client_external_id: 'MRN-12345',
  goal_key: 'G1',
  parent_goal_key: '',
  domain: 'Communication',
  program: 'Requesting',
  goal: 'Mands for preferred items',
  target: '',
  status: 'Active',
  date_initiated: '2026-01-15',
  date_met: '',
};

export const downloadGoalImportTemplate = (mode: 'single' | 'multi' = 'multi'): void => {
  const headers = goalTemplateHeaders(mode);
  const sample = Object.fromEntries(headers.map((h) => [h, SAMPLE_ROW[h] ?? '']));
  downloadTemplateCsv([...headers], [sample], 'goals-import-template.csv');
};
